"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LIVECHAT_STATUS = exports.LIVECHAT_POLLING_STOP = exports.LIVECHAT_POLLING_START = exports.LIVECHAT_LAUNCH = exports.LIVECHAT_CONVERSATION_INFO = exports.LIVECHAT_ABC_SUPPORTED = void 0;
const LIVECHAT_ABC_SUPPORTED = 'LIVECHAT_ABC_SUPPORTED';
exports.LIVECHAT_ABC_SUPPORTED = LIVECHAT_ABC_SUPPORTED;
const LIVECHAT_CONVERSATION_INFO = 'LIVECHAT_CONVERSATION_INFO';
exports.LIVECHAT_CONVERSATION_INFO = LIVECHAT_CONVERSATION_INFO;
const LIVECHAT_LAUNCH = 'LIVECHAT_LAUNCH';
exports.LIVECHAT_LAUNCH = LIVECHAT_LAUNCH;
const LIVECHAT_POLLING_START = 'LIVECHAT_POLLING_START';
exports.LIVECHAT_POLLING_START = LIVECHAT_POLLING_START;
const LIVECHAT_POLLING_STOP = 'LIVECHAT_POLLING_STOP';
exports.LIVECHAT_POLLING_STOP = LIVECHAT_POLLING_STOP;
const LIVECHAT_STATUS = 'LIVECHAT_STATUS';
exports.LIVECHAT_STATUS = LIVECHAT_STATUS;